import React from 'react';
import { Link } from 'react-router-dom';
import { LuCircleAlert, LuHouse } from 'react-icons/lu';
import EmptyState from './EmptyState';
import Button from './Button';

/** Full-page error (report not found, access denied…) with a way back home. */
export const ErrorMessage = ({ message, title = 'Impossible d\'afficher cette page', showHomeLink = true }) => (
  <div className="mx-auto w-full max-w-xl px-4 py-10">
    <EmptyState
      bordered
      icon={LuCircleAlert}
      tone="red"
      title={title}
      description={message}
      action={showHomeLink && (
        <Button as={Link} to="/" icon={LuHouse}>
          Retour à l'accueil
        </Button>
      )}
    />
  </div>
);

export default ErrorMessage;
